export default {
    state: {
        categories: null,
        categoriesMeta: null,
    },
    mutations: {
        SET_CATEGORIES_DATA(state, payload){
            state.categories = payload.data;
            state.categoriesMeta = payload.meta;
        },
        ADD_TO_CATEGORIES(state, category){
            state.categories.push(category);
        },
        UNSHIFT_CATEGORIES(state, category){
            state.categories.unshift(category);
        },
        DELETE_FROM_CATEGORIES(state, id){
            state.categories = state.categories.filter(category=>category.id!==id);
        },
        UPDATE_CATEGORY_DATA(state, data){
            state.categories = state.categories.map(item=>{
                if (item.id === data.id){
                    Object.assign(item, data);
                }
                return item;
            });
        },
    },
    actions: {
        getCategories({commit}, payload){
            let url = '/categories?v=1';
            if (payload && payload.page){
                url += `&page=${payload.page}`
            }
            if (payload && payload.query){
                url += `&query=${payload.query}`
            }
            return window.axios.get(url).then(response=>{
                commit('SET_CATEGORIES_DATA', response.data);
            });
        },
        createCategory({commit}, payload){
            let url = '/categories';
            return window.axios.post(url, payload.data).then(response=>{
                commit('UNSHIFT_CATEGORIES', response.data.data);
            });
        },
        editCategory({commit}, payload){
            let url = '/categories/' + payload.data.id;
            return window.axios.put(url, payload.data.data).then(response=>{
                commit('UPDATE_CATEGORY_DATA', response.data.data);
            });
        },
        deleteCategory({commit}, payload){
            let url = '/categories/' + payload.data.id;
            return window.axios.delete(url).then(response=>{
                commit('DELETE_FROM_CATEGORIES', payload.data.id);
            });
        },
    }
}